import React from 'react';
import ComparisonBaseCell from '../../../ComparisonTable/ComparisonBaseCell';
import ComparisonScroller from '../../../ComparisonScroller';
import { formatMessage } from '../../../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import { Tooltip } from '@/views/components/tooltips';

type Props = {
  items: ComparisonItem[];
  scrollContainerRef?: HTMLElement;
  tablePaddingRef?: HTMLElement;
  isEditPinned: boolean;
};

const metricLabels = [
  'Charts.Growth.AnnualizedRateOfReturn',
  'Charts.Growth.GrossRateOfReturn',
  'RiskMetrics.StandardDeviation',
  'RiskMetrics.MaximumDrawdown',
  'RiskMetrics.AverageDrawdownDuration',
  'RiskMetrics.AverageRecoveryDuration',
  'RiskMetrics.Beta',
  'RiskMetrics.SharpeRatio',
  'RiskMetrics.SortinoRatio',
  'RiskMetrics.UpsideDownside',
];

const HistoricalScenariosTableLabels = ({ items, scrollContainerRef, tablePaddingRef, isEditPinned }: Props) => (
  <div className="historical-scenario-table-labels">
    <div className="historical-scenario-labels-actions d-flex flex-column justify-content-center align-items-start">
      <ComparisonScroller items={items} scrollContainerRef={scrollContainerRef} tablePaddingRef={tablePaddingRef} isEditPinned={isEditPinned} />
    </div>

    <div className="historical-scenario-table-container">
      <ComparisonBaseCell className="historical-scenario-table-header">
        <span className="label-container">
          <span className="label">
            <span id="hs-category-header-keyMetrics">{formatMessage('Comparison.HistoricalScenarios.KeyMetricsTooltip.Title')}</span>
            <Tooltip
              className="custom-tooltip-v2"
              message={formatMessage('Comparison.HistoricalScenarios.KeyMetricsTooltip.Description')}
              place="right"
              title={formatMessage('Comparison.HistoricalScenarios.KeyMetricsTooltip.Title')}
            >
              <span tabIndex={0} aria-label={formatMessage('Comparison.HistoricalScenarios.KeyMetricsTooltip.Title')}>
                <i className="icon-info displayed-icon" />
              </span>
            </Tooltip>
          </span>
        </span>
      </ComparisonBaseCell>

      <div className="historical-scenario-category">
        {metricLabels.map((labelKey, idx) => (
          <ComparisonBaseCell className="historical-scenario-category-metric" key={idx} role="columnheader" id={`field-header-${labelKey}`}>
            <span className="label-container">
              <span className="label">{formatMessage(labelKey)}</span>
            </span>
          </ComparisonBaseCell>
        ))}
      </div>
    </div>
  </div>
);

export default HistoricalScenariosTableLabels;
